/**
 * Created by Alex Aguilar on 7/20/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('regions', {
                parent: 'app',
                url: '/regions',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/region/regions.html',
                        controller: 'regionsController',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('regions')
                            }],
                            'regions': ['regionService', '$stateParams', function (regionService, $stateParams) {
                                return regionService.getPageRegions($stateParams.page, $stateParams.size);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['region']);
                            }]
                        }
                    }
                }
            })
            .state('regionNew', {
                parent: 'app',
                url: '/region/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/region/newRegion.html',
                        controller: 'newRegionController',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('regions')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['region']);
                            }]
                        }
                    }
                }
            })
            .state('regionEdit', {
                parent: 'app',
                url: '/region/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/adminAirport/region/editRegion.html',
                        controller: 'editRegionController',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('regions')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            'region': ['regionService', '$stateParams', function(regionService, $stateParams) {
                                return regionService.getRegion($stateParams.id)
                            }],
                            'regionId': ['$stateParams', function($stateParams) {
                                return $stateParams.id
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['region']);
                            }]
                        }
                    }
                }
            })
            .state('regionDelete', {
                parent: 'regions',
                url: '/region/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminAirport/region/deleteRegion.html',
                        controller: 'deleteRegionController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'regionId': [function() {
                                return $stateParams.id
                            }],
                            'region': ['regionService', function(regionService) {
                                return regionService.getRegion($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['region']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('regions', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
